import { DefaultValueConfig } from '@headless-workspace/config';
import { PropsWithButton } from '@headless-workspace/glow-ds';
import { Image } from '@headless-workspace/typings';
import { ObjectHelpers, StringHelpers } from '@headless-workspace/utils';
import { ProductDetailBannerType } from '../ProductDetailBannerType';
import { ProductDetailBannerValue } from '../ProductDetailBannerValue';
import { BrandCornerBannerDTO } from './BrandCornerBannerDTO';

export type BrandCornerBannerValue = {
    type: ProductDetailBannerType;
    title: string;
    description: string;
    image: Image;
} & PropsWithButton;

export const isBrandCornerBanner = (banner: ProductDetailBannerValue): banner is BrandCornerBannerValue => {
    return banner.type === ProductDetailBannerType.BrandCorner;
};

export const mapBrandCornerBanner = ({
    image,
    title,
    description,
    cta,
}: BrandCornerBannerDTO): BrandCornerBannerValue => {
    const imageSrc =
        image?.default && !StringHelpers.isNotEmpty(image.default)
            ? image.default
            : image?.small
              ? image.small
              : DefaultValueConfig.imagePlaceholder;
    const imageAlt = image?.alt;

    return {
        type: ProductDetailBannerType.BrandCorner,
        title: title ?? '',
        description: description ?? '',
        button: { label: cta.label, href: cta.link },
        image: ObjectHelpers.createImageWithSrc(imageSrc, imageAlt),
    };
};
